import React, { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";

const allProducts = [
  {
    id: "m1",
    name: "Seramik Kupa 1",
    image: "/images/mug-image-1.png",
    description: "Sade ve yaldız detaylı el yapımı kupa. ade ve yaldız detaylı el yapımı kupa. ade ve yaldız detaylı el yapımı kupa. ade ve yaldız detaylı el yapımı kupa. ade ve yaldız detaylı el yapımı kupa. ade ve yaldız detaylı el yapımı kupa. ade ve yaldız detaylı el yapımı kupa. ade ve yaldız detaylı el yapımı kupa. ade ve yaldız detaylı el yapımı kupa. ade ve yaldız detaylı el yapımı kupa. ade ve yaldız detaylı el yapımı kupa. ade ve yaldız detaylı el yapımı kupa. ade ve yaldız detaylı el yapımı kupa. ade ve yaldız detaylı el yapımı kupa. ade ve yaldız detaylı el yapımı kupa. ade ve yaldız detaylı el yapımı kupa. ade ve yaldız detaylı el yapımı kupa. ade ve yaldız detaylı el yapımı kupa. ade ve yaldız detaylı el yapımı kupa. ade ve yaldız detaylı el yapımı kupa. ade ve yaldız detaylı el yapımı kupa. ",
    category: "Kupa"
  },
  {
    id: "m2",
    name: "Seramik Kupa 2",
    image: "/images/mug-image-2.png",
    description: "Koyu sır ile işlenmiş zarif seramik kupa. Koyu sır ile işlenmiş zarif seramik kupa. Koyu sır ile işlenmiş zarif seramik kupa. Koyu sır ile işlenmiş zarif seramik kupa. Koyu sır ile işlenmiş zarif seramik kupa. Koyu sır ile işlenmiş zarif seramik kupa. Koyu sır ile işlenmiş zarif seramik kupa. Koyu sır ile işlenmiş zarif seramik kupa. Koyu sır ile işlenmiş zarif seramik kupa. Koyu sır ile işlenmiş zarif seramik kupa. Koyu sır ile işlenmiş zarif seramik kupa. Koyu sır ile işlenmiş zarif seramik kupa. Koyu sır ile işlenmiş zarif seramik kupa. Koyu sır ile işlenmiş zarif seramik kupa. Koyu sır ile işlenmiş zarif seramik kupa. Koyu sır ile işlenmiş zarif seramik kupa. Koyu sır ile işlenmiş zarif seramik kupa. Koyu sır ile işlenmiş zarif seramik kupa. Koyu sır ile işlenmiş zarif seramik kupa. Koyu sır ile işlenmiş zarif seramik kupa.",
    category: "Kupa"
  },
  {
    id: "m3",
    name: "Seramik Kupa 3",
    image: "/images/mug-image-3.png",
    description: "Koyu sır ile işlenmiş zarif seramik kupa. Koyu sır ile işlenmiş zarif seramik kupa. Koyu sır ile işlenmiş zarif seramik kupa. Koyu sır ile işlenmiş zarif seramik kupa. Koyu sır ile işlenmiş zarif seramik kupa. Koyu sır ile işlenmiş zarif seramik kupa. Koyu sır ile işlenmiş zarif seramik kupa. Koyu sır ile işlenmiş zarif seramik kupa. Koyu sır ile işlenmiş zarif seramik kupa. Koyu sır ile işlenmiş zarif seramik kupa. Koyu sır ile işlenmiş zarif seramik kupa. Koyu sır ile işlenmiş zarif seramik kupa. Koyu sır ile işlenmiş zarif seramik kupa. Koyu sır ile işlenmiş zarif seramik kupa. Koyu sır ile işlenmiş zarif seramik kupa. Koyu sır ile işlenmiş zarif seramik kupa. Koyu sır ile işlenmiş zarif seramik kupa. Koyu sır ile işlenmiş zarif seramik kupa. Koyu sır ile işlenmiş zarif seramik kupa. Koyu sır ile işlenmiş zarif seramik kupa.",
    category: "Kupa"
  },
  {
    id: "v1",
    name: "El Yapımı Vazo 1",
    image: "/images/vase-image-1.png",
    description: "Koyu sır ile işlenmiş zarif seramik kupa. Koyu sır ile işlenmiş zarif seramik kupa. Koyu sır ile işlenmiş zarif seramik kupa. Koyu sır ile işlenmiş zarif seramik kupa. Koyu sır ile işlenmiş zarif seramik kupa. Koyu sır ile işlenmiş zarif seramik kupa. Koyu sır ile işlenmiş zarif seramik kupa. Koyu sır ile işlenmiş zarif seramik kupa. Koyu sır ile işlenmiş zarif seramik kupa. Koyu sır ile işlenmiş zarif seramik kupa. Koyu sır ile işlenmiş zarif seramik kupa. Koyu sır ile işlenmiş zarif seramik kupa. Koyu sır ile işlenmiş zarif seramik kupa. Koyu sır ile işlenmiş zarif seramik kupa. Koyu sır ile işlenmiş zarif seramik kupa. Koyu sır ile işlenmiş zarif seramik kupa. Koyu sır ile işlenmiş zarif seramik kupa. Koyu sır ile işlenmiş zarif seramik kupa. Koyu sır ile işlenmiş zarif seramik kupa. Koyu sır ile işlenmiş zarif seramik kupa.",
    category: "Vazo"
  },
  {
    id: "v2",
    name: "El Yapımı Vazo 2",
    image: "/images/vase-image-2.png",
    description: "Koyu sır ile işlenmiş zarif seramik kupa. Koyu sır ile işlenmiş zarif seramik kupa. Koyu sır ile işlenmiş zarif seramik kupa. Koyu sır ile işlenmiş zarif seramik kupa. Koyu sır ile işlenmiş zarif seramik kupa. Koyu sır ile işlenmiş zarif seramik kupa. Koyu sır ile işlenmiş zarif seramik kupa. Koyu sır ile işlenmiş zarif seramik kupa. Koyu sır ile işlenmiş zarif seramik kupa. Koyu sır ile işlenmiş zarif seramik kupa. Koyu sır ile işlenmiş zarif seramik kupa. Koyu sır ile işlenmiş zarif seramik kupa. Koyu sır ile işlenmiş zarif seramik kupa. Koyu sır ile işlenmiş zarif seramik kupa. Koyu sır ile işlenmiş zarif seramik kupa. Koyu sır ile işlenmiş zarif seramik kupa. Koyu sır ile işlenmiş zarif seramik kupa. Koyu sır ile işlenmiş zarif seramik kupa. Koyu sır ile işlenmiş zarif seramik kupa. Koyu sır ile işlenmiş zarif seramik kupa.",
    category: "Vazo"
  },
  {
    id: "v3",
    name: "El Yapımı Vazo 3",
    image: "/images/vase-image-3.png",
    description: "Koyu sır ile işlenmiş zarif seramik kupa. Koyu sır ile işlenmiş zarif seramik kupa. Koyu sır ile işlenmiş zarif seramik kupa. Koyu sır ile işlenmiş zarif seramik kupa. Koyu sır ile işlenmiş zarif seramik kupa. Koyu sır ile işlenmiş zarif seramik kupa. Koyu sır ile işlenmiş zarif seramik kupa. Koyu sır ile işlenmiş zarif seramik kupa. Koyu sır ile işlenmiş zarif seramik kupa. Koyu sır ile işlenmiş zarif seramik kupa. Koyu sır ile işlenmiş zarif seramik kupa. Koyu sır ile işlenmiş zarif seramik kupa. Koyu sır ile işlenmiş zarif seramik kupa. Koyu sır ile işlenmiş zarif seramik kupa. Koyu sır ile işlenmiş zarif seramik kupa. Koyu sır ile işlenmiş zarif seramik kupa. Koyu sır ile işlenmiş zarif seramik kupa. Koyu sır ile işlenmiş zarif seramik kupa. Koyu sır ile işlenmiş zarif seramik kupa. Koyu sır ile işlenmiş zarif seramik kupa.",
    category: "Vazo"
  }
];

const ProductDetail = () => {
  const { id } = useParams();
  const product = allProducts.find((p) => p.id === id);
  const [zoomed, setZoomed] = useState(false);

  // ESC ile kapatma
  useEffect(() => {
    const handleKeyDown = (e) => {
      if (e.key === "Escape") setZoomed(false);
    };
    window.addEventListener("keydown", handleKeyDown);
    return () => window.removeEventListener("keydown", handleKeyDown);
  }, []);

  if (!product) {
    return <div className="text-center py-20 text-xl text-gray-500">Ürün bulunamadı.</div>;
  }

  return (
    <div className="min-h-screen px-6 py-12 bg-white max-w-6xl mx-auto text-left">
      <div className="grid grid-cols-1 md:grid-cols-2 gap-20 items-start">
        {/* Sol kısım: Büyük görsel ve küçük görseller */}
        <div>
          <img
            src={product.image}
            alt={product.name}
            onClick={() => setZoomed(true)}
            className="w-full max-h-[500px] object-contain mb-4 cursor-zoom-in"
          />
          {/* Küçük görseller için örnek (ileride birden fazla olursa kullanılabilir) */}
          <div className="flex gap-2">
            <img
              src={product.image}
              alt={product.name}
              className="w-20 h-20 object-cover border rounded"
            />
            {/* Başka küçük görseller buraya eklenebilir */}
          </div>
        </div>
  
        {/* Sağ kısım: Ürün açıklamaları */}
        <div>
          <h1 className="text-3xl font-bold mb-2">{product.name}</h1>
          <p className="text-sm text-gray-500 mb-4">{product.category}</p>
          <p className="text-lg text-gray-700 mb-6">{product.description}</p>
  
          <a
            href="https://www.shopier.com/seratics"
            target="_blank"
            rel="noopener noreferrer"
            className="inline-block bg-stone-900 text-white px-5 py-3 rounded-full text-sm font-medium hover:bg-stone-800 transition"
          >
            Shopier'den Satın Al
          </a>
        </div>
      </div>
  
      {/* Alt navigasyon */}
      <div className="grid grid-cols-1 md:grid-cols-2 gap-20 items-start px-2 py-8 mt-12 border-t">
        <Link to="/" className="text-stone-600 hover:underline text-sm text-end">Ana Sayfa</Link>
        <Link to="/all-products" className="text-stone-600 hover:underline text-sm text-start">Katalog</Link>
      </div>
  
      {/* 🔍 Lightbox */}
      {zoomed && (
        <div
          className="fixed inset-0 bg-black bg-opacity-80 flex items-center justify-center z-50 transition-opacity duration-300"
          onClick={() => setZoomed(false)}
        >
          <button
            onClick={() => setZoomed(false)}
            className="absolute top-6 right-6 text-white text-3xl font-bold hover:text-gray-300 z-50"
            aria-label="Kapat"
          >
            ×
          </button>
          <img
            src={product.image}
            alt="Zoomed"
            className="max-w-full max-h-[90vh] object-contain shadow-2xl rounded-lg"
          />
        </div>
      )}
    </div>
  );
  
};

export default ProductDetail;
